module.exports = __webpack_public_path__ + "img/logo-weshare.5d26733c.png";